import React, { useState, useEffect } from 'react';
import { Typography, Button, Form, Input, Space, Card, Row, Col, message, Tooltip, Spin, Modal, Divider } from 'antd';
import { QuestionCircleOutlined, DollarOutlined, LeftOutlined, } from '@ant-design/icons';
import SidebarLayoutConsumer from './SidebarLayoutConsumer';
import _AdministratorService from '../../../modules/AdministratorService';
import { CAPITAL_PROVIDER_ADDED_MSG, COMMON_ERROR_MSG } from '../../../constants/constants';
import { routes } from '../../../routes/Routes';
import { useHistory, useLocation } from "react-router-dom";
import CurrencyInput from '../../../components/CurrencyInput';
import PhoneInput from "react-phone-input-auto-format";
import DonutChart from '../../../components/DonutChart';
import IntegerInput from '../../../components/IntergerInput';
import ApplicationListConsumerPortal from './ApplicationListConsumerPortal';
import moment from 'moment';
import _commonService from '../../../modules/commonService';
import IntegerDecimalInput from '../../../components/IntegerDecimalInput';

const { Title, Text } = Typography;

const AddEditSponsersForAdministrator = () => {
    const [form] = Form.useForm();
    const history = useHistory();
    const location = useLocation();
    const [allApplications, setAllApplications] = useState([]);
    const adminEmail = localStorage.getItem("adminiStratorLoginEmail");

    let data = location.state;
    let sponsId = 0;
    if (data && data.sponserId) {
        sponsId = data.sponserId;
    }

    const [sponserId] = useState(sponsId);

    const [loading, setLoading] = useState(false);
    const [sponserData, setSponserData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [fromDate, setFromDate] = useState(null);
    const [toDate, setToDate] = useState(null);
    const [sortBy, setSortBy] = useState(null);
    const [pageIndex, setPageIndex] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [totalCount, setTotalCount] = useState(0);
    const [debouncedSearchText, setDebouncedSearchText] = useState("");
    const [applicationStatus, setApplicationStatus] = useState(0);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [password, setPassword] = useState("");
    const [passwordError, setPasswordError] = useState("");

    const showModal = () => {
        setIsModalOpen(true);
        setPassword("");
        setPasswordError("");
    };

    const handleOk = async () => {
        if (!password.trim()) {
            setPasswordError("Administrator Login Password is required");
            return;
        }

        let reqObj = {
            "BankerPassword": password,
            "BankerId": Number(localStorage.getItem("administratorUserId")),
            "SponserId": sponserId
        }

        setLoading(true);
        try {
            const res = await _AdministratorService.deleteSponserApplicantsData(reqObj);
            if (res.data.IsSuccess) {
                message.success(res.data.Message);
                setPasswordError("");
                setIsModalOpen(false);
                history.push(routes.sponsorsCapitalProvider.path);
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        setPassword("");
        setPasswordError("");
    };

    useEffect(() => {
        if (sponserId && sponserId > 0) {
            getApplicationListBySponserId(sponserId);
        }
    }, [debouncedSearchText, applicationStatus, fromDate, toDate, sortBy, pageIndex, pageSize]);

    // useEffect(() => {
    //     if (debouncedSearchText !== "") {
    //         setPageIndex(1);
    //         setPageSize(10);
    //     }
    // }, [debouncedSearchText]);

    useEffect(() => {
        setPageIndex(1);
        setPageSize(10);
    }, [debouncedSearchText]);


    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearchText(searchTerm && searchTerm.trim());
        }, 900);

        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm]);

    // const getApplicationListBySponserId = async () => {
    //     const params = {
    //         sponserId: sponserId,
    //         ByAppStatus: applicationStatus,
    //         startDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : "",
    //         endDate: toDate ? moment(toDate).format("YYYY-MM-DD") : "",
    //         pageIndex,
    //         pageSize,
    //         searchTerm: debouncedSearchText,
    //         sortBy,
    //         sortAsc: true,
    //     };

    //     setLoading(true);
    //     try {
    //         const res = await _AdministratorService.getApplicationListBySponserId(params);
    //         if (res.data.IsSuccess) {
    //             let resObj = res?.data?.Obj?.List;
    //             setAllApplications(resObj);
    //             setTotalCount(res?.data?.Obj?.TotalRecords || 0);
    //             setLoading(false);
    //         } else {
    //             message.error(res.data.Message || COMMON_ERROR_MSG);
    //             setLoading(false);
    //         }
    //     } catch (error) {
    //         message.error(COMMON_ERROR_MSG);
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const getApplicationListBySponserId = async () => {
        const params = {
            sponserId,
            ByAppStatus: applicationStatus,
            startDate: fromDate ? moment(fromDate).format("YYYY-MM-DD") : "",
            endDate: toDate ? moment(toDate).format("YYYY-MM-DD") : "",
            pageIndex,
            pageSize,
            searchTerm: debouncedSearchText,
            sortBy,
            sortAsc: true,
        };

        setLoading(true);
        try {
            const res = await _AdministratorService.getApplicationListBySponserId(params);

            if (res?.data?.IsSuccess) {
                setAllApplications(res?.data?.Obj?.List || []);
                setTotalCount(res?.data?.Obj?.TotalRecords || 0);
            } else {
                message.error(res?.data?.Message || COMMON_ERROR_MSG);
            }
        } catch (error) {
            message.error(COMMON_ERROR_MSG);
        } finally {
            setLoading(false);
        }
    };


    const handleClearFilters = () => {
        setSearchTerm("");
        setFromDate(null);
        setToDate(null);
        setSortBy(null);
        setApplicationStatus(0);
        setPageIndex(1);
        setPageSize(10);
    };

    const handlePaginationChange = (page, size) => {
        setPageIndex(page);
        setPageSize(size);
    };

    useEffect(() => {
        if (sponserId && sponserId > 0) {
            getSponserDataBySponserId();
        } else {
            setSponserData({ applicants: [{ name: '', contactNumber: '', email: '', gpCommitment: null, roleId: "", }] })
        }
    }, []);

    const getSponserDataBySponserId = async () => {
        try {
            setLoading(true);

            const res = await _AdministratorService.getSponserDataBySponserId(sponserId);

            if (res.data.IsSuccess) {
                let resObj = res.data.Obj;
                setSponserData({
                    ...resObj,
                    firm: resObj.CompanyName,
                    capitalProviderEmail: resObj.CPEmail,
                    businessPhone: resObj.ContactNumber,
                    typeOfBusiness: resObj.TypeOfBusiness,
                    yearsAssociated: resObj.YearsAssociated,
                    streetAddress: resObj.StreetAddress,
                    city: resObj.City,
                    state: resObj.State,
                    zip: resObj.ZipCode,
                    interestRate: resObj.IntrestExpense,
                    underWritingObjId: resObj?.underWritingModel?.Id,
                    tdsrThresholdvalue: resObj?.underWritingModel?.TdsrThresholdvalue,
                    leverageThresholdvalue: resObj?.underWritingModel?.LeverageThresholdvalue,
                    cbrThresholdvalue: resObj?.underWritingModel?.CbrThresholdvalue,
                    debtIncomeRatioThresholdvalue: resObj?.underWritingModel?.DebtIncomeRatioThresholdvalue,
                });
            } else {
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => form.resetFields(), [sponserData]);


    const onFinish = async (values) => {
        setLoading(true);
        let reqObj = {
            "Id": sponserId || 0,
            "CompanyName": values.firm,
            "ContactNumber": values.businessPhone,
            "CPEmail": values.CPEmail,
            "TypeOfBusiness": values.typeOfBusiness,
            "YearsAssociated": values.yearsAssociated,
            "TotalProgrameSize": values.TotalProgrameSize,
            "AdvanceRate": values.AdvanceRate,
            "MaxLTV": values.MaxLTV,
            "IntrestExpense": values.interestRate,
            "StreetAddress": values.streetAddress,
            "City": values.city,
            "State": values.state,
            "ZipCode": values.zip,
            "BankerId": Number(localStorage.getItem("administratorUserId")),
            "underWritingModel": {
                "Id": sponserData && sponserData.underWritingObjId > 0 ? sponserData.underWritingObjId : 0,
                "TdsrThresholdvalue": values.tdsrThresholdvalue,
                "LeverageThresholdvalue": values.leverageThresholdvalue,
                "CbrThresholdvalue": values.cbrThresholdvalue,
                "DebtIncomeRatioThresholdvalue": values.debtIncomeRatioThresholdvalue,
            },
            "sponserApplicantModels": null
        }

        try {
            const res = await _AdministratorService.addUpdateSponser(reqObj);
            if (res.data.IsSuccess) {
                setLoading(false);
                message.success(res.data.Message || CAPITAL_PROVIDER_ADDED_MSG);
                history.push({ pathname: routes.sponsorsCapitalProvider.path });
            } else {
                setLoading(false);
                message.error(res.data.Message ? res.data.Message : COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            console.log(err);
        }
        finally {
            setLoading(false);
        }
    };

    const onBack = () => {
        history.push(routes.sponsorsCapitalProvider.path);
    }

    return (
        <Spin spinning={loading}>
            <SidebarLayoutConsumer>
                <div className='add-edit-sponser-administrator'>
                    <div>
                        <Form.Item>
                            <Button
                                onClick={onBack}
                                icon={<LeftOutlined />}
                                className='backbtn'
                            >
                                Back to Capital Providers
                            </Button>
                        </Form.Item>
                    </div>
                    {/* <Card className='add-edit-sponsers cardViewMain'> */}
                    <Form
                        form={form}
                        layout="vertical"
                        onFinish={onFinish}
                        initialValues={sponserData}
                        className='inputDisabledBlackColor'
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                e.preventDefault();
                            }
                        }}
                    >

                        <Col span={24}>
                            <Row gutter={[16, 16]} className='baseAlign'>
                                <Col span={18}>

                                    <Title level={3}>{sponserId > 0 ? "Edit" : "New"} Capital Provider</Title>
                                    <text>Configure provider information and underwriting criteria.</text>
                                </Col>
                                <Col span={6}>
                                    <Form.Item>
                                        <Button
                                            type="primary" htmlType="submit" style={{ float: "right" }}>
                                            Save Changes
                                        </Button>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Col>
                        <Row gutter={[16, 16]} >
                            <Col
                                xs={24}
                                lg={18}
                                md={18}
                                sm={18}
                                xl={18} >

                                <div className='capital-provider-details'>
                                    <Row gutter={[16, 16]}>
                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 12 }}
                                            md={{ span: 12 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <Form.Item
                                                label="Capital Provider"
                                                name="firm"
                                                rules={[{ required: true, message: 'Capital Provider is required' }]}
                                            >
                                                <Input
                                                    placeholder='Enter Capital Provider'
                                                    maxLength={100}
                                                // disabled={sponserId && sponserId > 0 ? true : false}
                                                />
                                            </Form.Item>
                                        </Col>

                                        {/* <Col
                                        className="gutter-row"
                                        xs={{ span: 12 }}
                                        lg={{ span: 12 }}
                                        md={{ span: 12 }}
                                        sm={{ span: 12 }}
                                        xl={{ span: 12 }}
                                    >
                                        <Form.Item
                                            label="Email"
                                            name="CPEmail"
                                            rules={[
                                                { required: true, message: 'Email is required' },
                                                { type: 'email', message: 'Enter a valid Email' }
                                            ]}
                                        >
                                            <Input
                                                placeholder="Enter Email"
                                                autoComplete="email"
                                                maxLength={50}
                                            />
                                        </Form.Item>
                                    </Col> */}

                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 12 }}
                                            md={{ span: 12 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <Form.Item
                                                label="Email"
                                                name="CPEmail"
                                                rules={[
                                                    { required: true, message: 'Email is required' },
                                                    { type: 'email', message: 'Enter a valid Email' },
                                                    {
                                                        validator: (_, value) => {

                                                            if (!value) {
                                                                return Promise.resolve();
                                                            }

                                                            if (value === adminEmail) {
                                                                return Promise.reject(
                                                                    new Error("Capital Provider email cannot be the same as Administrator email")
                                                                );
                                                            }

                                                            return Promise.resolve();
                                                        }
                                                    }
                                                ]}
                                            >
                                                <Input
                                                    placeholder="Enter Email"
                                                    autoComplete="email"
                                                    maxLength={50}
                                                />
                                            </Form.Item>
                                        </Col>


                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 12 }}
                                            md={{ span: 12 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <Form.Item
                                                label="Business Phone"
                                                name="businessPhone"
                                                rules={[{ required: true, message: 'Business Phone is required' }]}
                                            >
                                                <PhoneInput
                                                    placeholder="Enter Business Phone"
                                                    inputComponent={Input}
                                                    autoComplete="off"
                                                    onChange={(value) => {
                                                        const digits = value.replace(/\D/g, '');
                                                        form.setFieldsValue({ businessPhone: digits });
                                                    }}
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 12 }}
                                            md={{ span: 12 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <Form.Item
                                                label="Type Of Business"
                                                name="typeOfBusiness"
                                                rules={[{ required: true, message: 'Type Of Business is required' }]}
                                            >
                                                <Input
                                                    placeholder='Enter Type Of Business'
                                                // disabled={sponserId && sponserId > 0 ? true : false}
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 12 }}
                                            md={{ span: 12 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <Form.Item
                                                label="Total Allocation $"
                                                name="TotalProgrameSize"
                                                rules={[{ required: true, message: 'Total Allocation is required' }]}
                                            >
                                                <CurrencyInput
                                                    placeholder="Enter Total Allocation"
                                                />
                                            </Form.Item>
                                        </Col>
                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 12 }}
                                            md={{ span: 12 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <Form.Item
                                                label="Advance Rate %"
                                                name="AdvanceRate"
                                                rules={[
                                                    { required: true, message: 'Advance Rate is required' },
                                                    {
                                                        validator: (_, value) => {
                                                            if (!value || (/^\d{1,3}$/.test(value) && parseInt(value, 10) <= 999)) {
                                                                return Promise.resolve();
                                                            }
                                                            return Promise.reject(new Error('Enter a valid 3-digit number (0-999)'));
                                                        },
                                                    },
                                                ]}
                                            >
                                                <IntegerInput maxLength={3}
                                                    placeholder="Enter Advance Rate"
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 12 }}
                                            md={{ span: 12 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <Form.Item
                                                label="Max LTV %"
                                                name="MaxLTV"
                                                rules={[
                                                    { required: true, message: 'Max LTV is required' },
                                                    {
                                                        validator: (_, value) => {
                                                            if (!value || (/^\d{1,3}$/.test(value) && parseInt(value, 10) <= 999)) {
                                                                return Promise.resolve();
                                                            }
                                                            return Promise.reject(new Error('Enter a valid 3-digit number (0-999)'));
                                                        },
                                                    },
                                                ]}
                                            >
                                                <IntegerInput maxLength={3}
                                                    placeholder="Enter Max LTV"
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 12 }}
                                            md={{ span: 12 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <Form.Item
                                                label="Interest Rate %"
                                                name="interestRate"
                                                rules={[
                                                    { required: true, message: 'Interest Rate is required' },
                                                ]}
                                            >
                                                <IntegerDecimalInput
                                                    maxLength={5}
                                                    placeholder="Enter Interest Rate"
                                                />
                                            </Form.Item>
                                        </Col>


                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 12 }}
                                            md={{ span: 12 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <Form.Item
                                                label="Street Address"
                                                name="streetAddress"
                                                rules={[{ required: true, message: 'Street Address is required' }]}
                                            >
                                                <Input
                                                    placeholder='Enter Street Address'
                                                    maxLength={500}
                                                // disabled={sponserId && sponserId > 0 ? true : false}
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 12 }}
                                            md={{ span: 12 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <Form.Item
                                                label="City"
                                                name="city"
                                                rules={[{ required: true, message: 'City is required' }]}
                                            >
                                                <Input
                                                    placeholder='Enter City'
                                                    maxLength={30}
                                                // disabled={sponserId && sponserId > 0 ? true : false}

                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 12 }}
                                            md={{ span: 12 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <Form.Item
                                                label="State"
                                                name="state"
                                                rules={[{ required: true, message: 'State is required' }]}
                                            >
                                                <Input
                                                    placeholder='Enter State'
                                                    // disabled={sponserId && sponserId > 0 ? true : false}
                                                    maxLength={30}
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 12 }}
                                            md={{ span: 12 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <Form.Item
                                                label="Zip Code"
                                                name="zip"
                                                rules={[{ required: true, message: 'Zip Code is required' }]}
                                            >
                                                <IntegerInput
                                                    placeholder='Enter Zip Code'
                                                    maxLength={10}
                                                // disabled={sponserId && sponserId > 0 ? true : false}
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                            <Col className='aligntext donut-chart-col'
                                xs={24}
                                lg={6}
                                md={6}
                                sm={6}
                                xl={6}>
                                <div className='capital-provider-details '>
                                    <Row justify="center" align="middle" gutter={[16, 16,]}>
                                        <Col span={24}>
                                            <DonutChart data={[
                                                { type: 'Remaining', value: Number(sponserData && sponserData.Remaining) },
                                                { type: 'Utilized', value: Number(sponserData && sponserData.Utilized) },

                                            ]}
                                                title="Budget"
                                            />
                                        </Col>
                                        <Col span={24}>
                                            <div className=' budget-details-div'>
                                                <Title level={5}>
                                                    Utilized:
                                                </Title>
                                                <span>
                                                    ${_commonService.formatNumberWithCommas(sponserData.Utilized)}
                                                </span>
                                            </div>
                                            <div className=' budget-details-div'>
                                                <Title level={5}>
                                                    Remaining:
                                                </Title>
                                                <span>
                                                    ${_commonService.formatNumberWithCommas(sponserData.Remaining)}
                                                </span>
                                            </div>
                                            <Divider className='divider' />

                                            <div className=' budget-details-div'>
                                                <Title level={5}>
                                                    Total Allocation:
                                                </Title>
                                                <span>
                                                    ${_commonService.formatNumberWithCommas(sponserData.TotalProgrameSize)}

                                                </span>
                                            </div>

                                            <Divider className='divider' />
                                        </Col>

                                        <Col span={24} className=''>
                                            <Row
                                                gutter={[16, 16]}
                                                className="active-loans-row">
                                                <Col span={24}>
                                                    <Title
                                                        level={5}
                                                    >
                                                        Active Loan Programs
                                                    </Title>
                                                </Col>
                                                <Col span={11} className='active-loans-data' style={{ marginRight: "16px" }}>

                                                    <div className=' budget-details-div-1' >
                                                        <Title level={5}>
                                                            In Progress:
                                                        </Title>
                                                        <span>
                                                            {_commonService.formatNumberWithCommas(sponserData.Inprogressed)}

                                                        </span>
                                                    </div>
                                                </Col>

                                                <Col span={11} className='active-loans-data'>

                                                    <div className='budget-details-div-1'>
                                                        <Title level={5}>
                                                            Funded:
                                                        </Title>
                                                        <span>
                                                            {_commonService.formatNumberWithCommas(sponserData.Approved)}
                                                        </span>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row></div>

                            </Col>

                        </Row>
                        {/* <div className='capital-provider-details'>
                        </div> */}

                        <Row gutter={[16, 16]}>
                            <Col
                                xs={{ span: 24 }}
                                lg={{ span: 18 }}
                                md={{ span: 18 }}
                                sm={{ span: 18 }}
                                xl={{ span: 18 }}>
                                <div className='capital-provider-application-criteria'>
                                    <Row gutter={[16, 16]}>
                                        <Col span={24} >
                                            <Title level={5}>Underwriting Criteria</Title></Col>
                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 12 }}
                                            md={{ span: 12 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <Form.Item
                                                name="tdsrThresholdvalue"
                                                label="TDSR Threshold %"
                                                rules={[{ required: true, message: "TDSR Threshold % is required" }]}
                                            >
                                                <IntegerInput
                                                    placeholder="Enter TDSR Threshold %"
                                                    maxLength={3}
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 12 }}
                                            md={{ span: 12 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <Form.Item
                                                name="leverageThresholdvalue"
                                                label="Leverage Threshold"
                                                rules={[{ required: true, message: "Leverage Threshold is required" }]}
                                            >
                                                <IntegerDecimalInput
                                                    placeholder="Enter Leverage Threshold"
                                                    maxLength={10}
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 12 }}
                                            md={{ span: 12 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <Form.Item
                                                name="cbrThresholdvalue"
                                                label="CBR Threshold"
                                                rules={[{ required: true, message: "CBR Threshold is required" }]}
                                            >
                                                <IntegerInput
                                                    placeholder="Enter CBR Threshold"
                                                    maxLength={10}
                                                />
                                            </Form.Item>
                                        </Col>

                                        <Col
                                            className="gutter-row"
                                            xs={{ span: 24 }}
                                            lg={{ span: 12 }}
                                            md={{ span: 12 }}
                                            sm={{ span: 12 }}
                                            xl={{ span: 12 }}
                                        >
                                            <Form.Item
                                                name="debtIncomeRatioThresholdvalue"
                                                label="Debt Income Ratio Threshold"
                                                rules={[{ required: false, message: "Debt Income Ratio Threshold is required" }]}
                                            >
                                                <IntegerDecimalInput
                                                    placeholder="Enter Debt Income Ratio Threshold"
                                                    maxLength={10}
                                                />
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>

                        {/* {sponserId && sponserId > 0 ?
                            <Card className='mb20 cardViewMain'>
                                <Row justify="space-around" align="middle">
                                    <Col>
                                        <Row
                                            className="iconFont"
                                            align="middle"
                                            justify="center"
                                            style={{ marginBottom: 16 }}
                                        >
                                            <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                                                <Text
                                                    strong
                                                    className="ant-card-head-title"
                                                    style={{ fontSize: 16, margin: 0 }}
                                                >
                                                    Limit Usage
                                                </Text>
                                                <Tooltip title="What is Limit Usage?">
                                                    <QuestionCircleOutlined
                                                        style={{ fontSize: 16, marginLeft: 4, cursor: 'pointer' }}
                                                    />
                                                </Tooltip>
                                            </div>
                                        </Row>

                                        <div style={{ textAlign: "center" }}>

                                            <DonutChart data={[
                                                { type: 'Remaining', value: Number(sponserData && sponserData.Remaining) },
                                                { type: 'Utilized', value: Number(sponserData && sponserData.Utilized) },

                                            ]}
                                                title="Budget"
                                            />
                                        </div>
                                    </Col>

                                    <Col>
                                        <Space direction="vertical" size={8}>
                                            <Title
                                                level={5}
                                                style={{
                                                    fontWeight: 600,
                                                    fontSize: 16,
                                                    marginBottom: 0,
                                                }}
                                            >
                                                <DollarOutlined /> Active Loan Programs
                                            </Title>
                                            <Text style={{ fontSize: 14 }}>
                                                In Progress: <strong>{sponserData && sponserData.Inprogressed || "0"}</strong>
                                            </Text>
                                            <Text style={{ fontSize: 14 }}>
                                                Funded: <strong>{sponserData && sponserData.Approved || "0"}</strong>
                                            </Text>
                                        </Space>
                                    </Col>
                                </Row>
                            </Card>

                            : <></>} */}

                        <Row className='capital-provider-dashboard'>
                            <Col span={24}>
                                {sponserId && (sponserId > 0) && (
                                    <ApplicationListConsumerPortal
                                        allApplications={allApplications}
                                        loading={loading}
                                        pageIndex={pageIndex}
                                        pageSize={pageSize}
                                        totalCount={totalCount}
                                        onPaginationChange={handlePaginationChange}
                                        searchTerm={searchTerm}
                                        fromDate={fromDate}
                                        toDate={toDate}
                                        sortBy={sortBy}
                                        onSearchChange={setSearchTerm}
                                        fromDateChange={setFromDate}
                                        toDateChange={setToDate}
                                        onSortChange={setSortBy}
                                        onClearFilters={handleClearFilters}
                                        // onApplicationStatusChange={setApplicationStatus}
                                        onApplicationStatusChange={(status) => {
                                            setApplicationStatus(status);
                                            setPageIndex(1);
                                            setPageSize(10);
                                        }}
                                        applicationStatusForFilter={applicationStatus}
                                    />
                                )}
                            </Col>
                        </Row>


                    </Form>
                    {/* </Card> */}

                    <Modal
                        title="Delete Capital Provider"
                        open={isModalOpen}
                        onOk={handleOk}
                        onCancel={handleCancel}
                        closable
                    >
                        <Text strong>Note: This action will delete Capital Provider <Text strong>({sponserData && sponserData.firm})</Text></Text>
                        <div>
                            <label className="label-align mt10">Banker Login Password<span className="asterick-color">*</span></label>
                        </div>
                        <Input.Password
                            autoComplete="current-password"
                            placeholder="Enter Banker Login Password"
                            maxLength={30}
                            value={password}
                            onChange={(e) => {
                                setPassword(e.target.value);
                                setPasswordError("");
                            }}
                        />
                        {passwordError && (
                            <div style={{ display: "block", marginTop: 8, color: "#ff4d4f" }}>
                                {passwordError}
                            </div>
                        )}
                    </Modal>
                </div>
            </SidebarLayoutConsumer>
        </Spin>
    );
};

export default AddEditSponsersForAdministrator;